import React, { useCallback, useEffect, useState } from 'react'
import { Table, Button, Input, PaginationItem, PaginationLink, Pagination, Row, Col, Label, FormGroup } from "reactstrap"
import { ActivadesRegimenHEDTO, ActividadPlanbyServidorHEDTO, ActividadesPlanificadas, DetalleGrupoActividadHEDTO, DetalleRegimenLaboralHEDTO, DetalleServidorPlanHEDTO, DetalleServidoresPlanificacion, DetalleServidoresPlanificacionHE, NovedadesServidoresHEDTO, ParamsHorasMesPlanificacionHEDTO } from './TypesPlanificacionHE';
import TableActividadServidorHE from './TableActividadServidorHE';
import { ReactComponent as VerSvg } from "./../../../../assets/icons/HorasExtras/VER.svg"
import { ReactComponent as EditarSvg } from "./../../../../assets/icons/HorasExtras/editar.svg"
import { ReactComponent as NovedadesSVG } from "./../../../../assets/icons/HorasExtras/novedades.svg"
import { GuardarPlanificacionbyServidor, ObtenerActividadesByRegimenHE, ObtenerActividadesByServidorHE } from './FunctionsPlanificacionHE';
import { alertService } from 'components/Varios/alert_service';

import WarningSVG from "./../../../../assets/icons/HorasExtras/Informativa R.svg"
import WarningInfSVG from "./../../../../assets/icons/HorasExtras/Informativa N.svg"
import SaveSVG from "./../../../../assets/icons/HorasExtras/Guardar.svg"
import ExitoSVG from "./../../../../assets/icons/HorasExtras/Exitosa.svg"
import ErrorSVG from "./../../../../assets/icons/HorasExtras/Error.svg"
import { ReactComponent as PdfSVG } from "./../../../../assets/icons/HorasExtras/PDF.svg";

import Swal from 'sweetalert2'
import { ObtenerFechaFormatoLocal, ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import ModalConfirmacionNew from 'components/Varios/Modals/ModalConfirmacionNew';
import { DetalleServidoresProyHEDTO, isParametroRegimenModificacion, isParametroRegimenPlanificacion, isParametroRegimenProyeccion, isProyeccion } from '../ProyeccionHE/TypesProyeccionDirectivo';
import { GuardarProyeccionbyServidor } from '../ProyeccionHE/FunctionsProyeccionDirectivoUnidad';


import { ReactComponent as IconoExcel } from "../../../../assets/icons/HorasExtras/Excel.svg"
import NumberFormat from 'react-number-format';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import { authenticationService } from 'services/authentication.service';
import { GetDocumentVistaPrevia } from 'helpers/files';
import ModalVistaPreviaDocumentos from 'components/Varios/Modals/ModalVistaPreviaDocumentos';
import { DetalleServidoresModificacionHE } from '../Modificación Presupuesto Unidad/TypesModificacion';
import { GuardarModificacionbyServidor } from '../Modificación Presupuesto Unidad/FunctionsModificacionPresupuesto';
import ModalVistaPreviaDocumento from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import { number } from 'yargs';
import { showAlertAviso } from '../../../Admin/Horas Extras/Parametros Horas Extras/Actividades/ActividadesHorasExtras';


type PropsTableServidoresPlanHE = {
    estadoPlanificacion: string,
    servidoresPlan: DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[],
    recargarInformacion: () => Promise<void>
    paramsHorasMesPlanificacionHE: ParamsHorasMesPlanificacionHEDTO[]
    novedadesServidores: NovedadesServidoresHEDTO[]
    mensajeNovedad: string,
    tipo: "PR" | "PL" | "MD",
    idUnidadAprueba?: number,
    nombreUnidadAprueba?: string,
    regimenLaboralesPlan?: DetalleRegimenLaboralHEDTO[];
    puedeRealizarAccion?: boolean
    guardarParcial?: () => void
    firmaryEnviar: () => Promise<void>
    solicitarReverso?: () => void
    mostrarGuardarParcial?: boolean | undefined;
    mostrarFirmaryEnviar?: boolean | undefined;
    mostrarSolicitarReverso?: boolean | undefined;
    mostrarReporteResumenProyPlanifExcel?: boolean
    loadingAccionReporteExcel?: boolean
    descargarResumenExcel?: () => Promise<void>
    gruposActividad: DetalleGrupoActividadHEDTO[];
    docPlanificacionUnidad?: string;
    idPlanificacionUnidad?: number;
    fechaDesde?: string;
    fechaHasta?: string;
}


type ModalConfirmacionActividad = {
    showModal: boolean,
    solicitud: DetalleServidorPlanHEDTO,
    content: HTMLElement | undefined
}


type ModalGuardarActividad = {
    showModal: boolean,
    solicitud: DetalleServidoresPlanificacionHE | DetalleServidoresProyHEDTO | DetalleServidoresModificacionHE | undefined,
    content: JSX.Element | undefined,
    tituloModal: string,
    mensajeEncabezado: undefined | string
}

type StateModalVistaPrevia = {
    loading: boolean,
    url: string
}

export default function TableServidoresPlanHE(props: PropsTableServidoresPlanHE) {

    const defaultDetalleServidorPlan: DetalleServidorPlanHEDTO = {
        idregimenLaboral: 0,
        idpersona: 0,
        rmu: '',
        actividades: [],
    };

    const defaultStateModalConfirmacionAct = {
        showModal: false,
        solicitud: defaultDetalleServidorPlan,
        content: undefined,
    }

    const defaultStateModalGuardarAct = {
        showModal: false,
        solicitud: undefined,
        content: undefined,
        tituloModal: '',
        mensajeEncabezado: undefined
    }

    const defaultStateModalVistaPrevia: StateModalVistaPrevia = {
        loading: false,
        url: ""
    }

    const { servidoresPlan, novedadesServidores, recargarInformacion, puedeRealizarAccion } = props;
    const [planificacionServidor, setPlanificacionServidor] = useState<DetalleServidorPlanHEDTO>(defaultDetalleServidorPlan);
    const [modalConfirmacionActividad, setModalConfirmacionActividad] = useState<ModalConfirmacionActividad>(defaultStateModalConfirmacionAct);

    const [stateModalVP, setstateModalVP] = useState<StateModalVistaPrevia>(defaultStateModalVistaPrevia)

    const [modalActividades, setModalActividades] = useState<ModalGuardarActividad>(defaultStateModalGuardarAct);

    const [updatedDetalleServidores, setUpdatedDetalleServidores] = useState<DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[]>(servidoresPlan);

    useEffect(() => {

        if (servidoresPlan) {
            setUpdatedDetalleServidores(servidoresPlan)
        }

    }, [servidoresPlan])


    const [expandedRows, setExpandedRows] = useState<Record<number, boolean>>({});

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [searchTerm, setSearchTerm] = useState('');

    const [sortColumn, setSortColumn] = useState<string | null>(null);
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);

    const listaFechaDesde = props.fechaDesde?.split("-").map(Number) || [];
    const listaFechaHasta = props.fechaHasta?.split("-").map(Number) || [];
    const mesDesde = listaFechaDesde[1];
    const mesHasta = listaFechaHasta[1];
    const factorMultiplicativo = mesHasta - (mesDesde - 1);

    let filteredServidores: DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[] = []

    // const filteredServidores = 
    if (updatedDetalleServidores && updatedDetalleServidores.length > 0) {

        if (isParametroRegimenProyeccion(updatedDetalleServidores[0])) {
            filteredServidores = (updatedDetalleServidores as DetalleServidoresProyHEDTO[]).filter(serv => {

                var filtroEstado: boolean = false
                return (
                    serv.nombrescompletos.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    serv.cargo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    serv.identificacion.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    serv.siglasregimenlaboral.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    filtroEstado
                )
            });
        }
        else if (isParametroRegimenPlanificacion(updatedDetalleServidores[0])) {
            filteredServidores = (updatedDetalleServidores as DetalleServidoresPlanificacionHE[]).filter(serv => {

                var filtroEstado: boolean = false
                return (
                    serv.nombrescompletos.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    serv.cargo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    serv.identificacion.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    serv.siglasregimenlaboral.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    filtroEstado
                )
            });
        }
        else if (isParametroRegimenModificacion(updatedDetalleServidores[0])) {
            filteredServidores = (updatedDetalleServidores as DetalleServidoresModificacionHE[]).filter(serv => {

                var filtroEstado: boolean = false
                return (
                    serv.nombrescompletos.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    serv.cargo.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    serv.identificacion.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    serv.siglasregimenlaboral.toLowerCase().includes(searchTerm.toLowerCase()) ||
                    filtroEstado
                )
            });
        }
    }

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    let currentRows = filteredServidores.slice(indexOfFirstRow, indexOfLastRow);

    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(filteredServidores.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }

    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    useEffect(() => {
        // Cargar los valores del localStorage cuando se monta el componente
        const savedRowsPerPage = localStorage.getItem('rowsPerPage');
        const savedSortColumn = localStorage.getItem('sortColumn');
        const savedSortDirection = localStorage.getItem('sortDirection');

        if (savedRowsPerPage) {
            setRowsPerPage(parseInt(savedRowsPerPage, 10));
        }
        if (savedSortColumn) {
            setSortColumn(savedSortColumn);
        }
        if (savedSortDirection) {
            setSortDirection(savedSortDirection);
        }
    }, []);

    const handleSort = (column) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        const newSortDirection = isAsc ? 'desc' : 'asc';

        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render

        localStorage.setItem('sortColumn', column);
        localStorage.setItem('sortDirection', newSortDirection);
    };


    const applySorting = (data) => {
        if (!sortColumn) return data;
        if (sortColumn !== null) {

            const sortedData = [...data].sort((a, b) => {
                var valA = a[sortColumn];
                var valB = b[sortColumn];

                //Falta validar que si ordena por estado, se escoja la propiedad dependiendo de si es planificación o proyección
                valA = valA ?? 0
                valB = valB ?? 0

                if (sortColumn === "estado") {
                    if (props.tipo === "PL") {
                        valA = a["strestadoplanificacion"];
                        valB = b["strestadoplanificacion"];
                    }
                    else if (props.tipo === "PR") {
                        valA = a["strestadoproyeccion"];
                        valB = b["strestadoproyeccion"];
                    }
                    else if (props.tipo === "MD") {
                        valA = a["strestadomodificacion"];
                        valB = b["strestadomodificacion"];
                    }
                }




                if (typeof valA === "string" && typeof valB === "string") {
                    // Sort strings using localeCompare
                    return valA.localeCompare(valB) * (sortDirection === 'asc' ? 1 : -1);
                } else if (typeof valA === "number" && typeof valB === "number") {
                    // Sort numbers directly

                    return (valA - valB) * (sortDirection === 'asc' ? 1 : -1);
                }

                // Handle potential cases where types are mixed or unexpected
                return 0;
            });
            return sortedData;
        }
        return data;
    };

    const sortedServidores = applySorting(filteredServidores);
    currentRows = sortedServidores.slice(indexOfFirstRow, indexOfLastRow);



    /*const applySorting = (data) => {
        if (!sortColumn) return data;
        if(sortColumn!==null){
            const sortedData = [...data].sort((a, b) => {
                const valA = a[sortColumn];
                const valB = b[sortColumn];
                return (valA < valB ? -1 : 1) * (sortDirection === 'asc' ? 1 : -1);
            });
            return sortedData;
        }
        return data;
    };

    const sortedServidores = applySorting(filteredServidores);
    currentRows = sortedServidores.slice(indexOfFirstRow, indexOfLastRow);*/

    const showNovedadesModal = (idServ: number) => {
        // Verificar si hay novedades para el servidor
        const novedades = novedadesServidores.filter(nov => nov.idPersona === idServ);
        if (novedades.length > 0) {
            // Formatear las fechas de las novedades y construir el mensaje
            const novedadesFormatted = novedades.map(n => {
                const fechaDesdeFormatted = new Date(n.fechaDesde).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });
                const fechaHastaFormatted = new Date(n.fechaHasta).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' });

                var tipoNovedad = n.tipoNovedad;

                //Se valida si se esta tratando con Informacion de Proyeccion para la tabla
                if (EsInformacionDeProyeccion(props.servidoresPlan)) {
                    tipoNovedad = n.descripcionNovedad
                }

                return `<p>El servidor/a tiene <strong>${tipoNovedad}</strong> desde el ${fechaDesdeFormatted} hasta el ${fechaHastaFormatted} por ${n.numDias} día(s).</p>`;
            }).join('');

            // Mostrar alerta con las novedades encontradas
            Swal.fire({
                title: 'Novedades del servidor',
                html: novedadesFormatted,
                imageUrl: `${WarningInfSVG}`,
                imageHeight: 100,
                customClass: {
                    popup: 'swal-wide'
                },
                confirmButtonText: 'Entendido',
                confirmButtonColor: '#243165',
            });
        }
    };

    /*const handleExpandRow = (idServ: number) => {
        const isRowCurrentlyExpanded = expandedRows[idServ];
        const currentExpandedRows = { ...expandedRows };
        currentExpandedRows[idServ] = !currentExpandedRows[idServ];
        setExpandedRows(currentExpandedRows);
        if (!isRowCurrentlyExpanded) {
            showNovedadesModal(idServ);
        }
    };*/

    const handleExpandRow = (idServ: number) => {
        var servidor: DetalleServidoresPlanificacionHE | DetalleServidoresProyHEDTO | DetalleServidoresModificacionHE | undefined
        if (currentRows && currentRows.length > 0) {
            if (esProyeccion) {
                servidor = (currentRows as DetalleServidoresProyHEDTO[]).find(serv => serv.idpersona === idServ);
            }
            else if (esModificacion) {
                servidor = (currentRows as DetalleServidoresModificacionHE[]).find(serv => serv.idpersona === idServ);
            }
            else {
                servidor = (currentRows as DetalleServidoresPlanificacionHE[]).find(serv => serv.idpersona === idServ);
            }
        }

        if (servidor) {
            showNovedadesModal(idServ);
            const tituloModal = `Actividades de el(la) servidor(a) ${servidor.nombrescompletos}`
            const content = GetHTMLServidorActividades(servidor); // Puedes ajustar esta función para obtener el contenido HTML que necesites

            setModalActividades({
                showModal: true,
                solicitud: servidor,
                content,
                tituloModal,
                mensajeEncabezado: GenerarMensajeEncabezadoModal(servidor, props.paramsHorasMesPlanificacionHE)
            });
        }
    };

    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(selectedRowsPerPage);
        setCurrentPage(1); // Reiniciar a la primera página al cambiar el número de filas por página

        localStorage.setItem('rowsPerPage', selectedRowsPerPage.toString());
    };


    function GetHTMLServidorPlanificado(servidor: DetalleServidorPlanHEDTO): React.ReactNode {
        let nombresCompletosServidor: string | undefined = "";

        if (currentRows && currentRows.length > 0) {
            if (isParametroRegimenProyeccion(currentRows[0])) {
                const detalleServidor = (currentRows as DetalleServidoresProyHEDTO[]).find(serv => serv.idpersona == servidor.idpersona);
                nombresCompletosServidor = detalleServidor?.nombrescompletos;
            }
            else if (isParametroRegimenModificacion(currentRows[0])) {
                const detalleServidor = (currentRows as DetalleServidoresModificacionHE[]).find(serv => serv.idpersona == servidor.idpersona);
                nombresCompletosServidor = detalleServidor?.nombrescompletos;
            }
            else if (isParametroRegimenPlanificacion(currentRows[0])) {
                const detalleServidor = (currentRows as DetalleServidoresPlanificacionHE[]).find(serv => serv.idpersona == servidor.idpersona);
                nombresCompletosServidor = detalleServidor?.nombrescompletos;
            }
        }

        const actividadesValidas = servidor.actividades.filter(act => act.idActividad !== 0); // Filtrar actividades con idActividad diferente a 0
        const totalHorasSuplementarias = actividadesValidas.reduce((acc, act) => acc + (act.horasSuplementarias || 0), 0);
        const totalHorasExtraordinarias = actividadesValidas.reduce((acc, act) => acc + (act.horasExtraordinarias || 0), 0);
        const totalHoras = totalHorasSuplementarias + totalHorasExtraordinarias;



        const htmlRowsSolicitudes = (
            <>
                <div className="modal-body">
                    <p><strong>Nombre Servidor:</strong> {nombresCompletosServidor}</p>
                    <Table responsive bordered className="table_planificacion_he">
                        <thead className="cabeceras_tabla_planificacion_he">
                            <tr>
                                <th>Actividad</th>
                                <th>Horas Suplementarias</th>
                                <th>Horas Extraordinarias</th>
                                {props.tipo === "PL" && <th>Observación</th>}
                            </tr>
                        </thead>
                        <tbody>
                            {actividadesValidas.map(act => (
                                <tr className='rows_tabla_planificacion_he' key={act.idActividad}>
                                    <td>{act.nombreActividad}</td>
                                    <td className='centrado'>{act.horasSuplementarias}</td>
                                    <td className='centrado'>{act.horasExtraordinarias}</td>
                                    {props.tipo === "PL" && <td>{act.observacion}</td>}
                                </tr>

                            ))}
                        </tbody>
                        <tfoot>
                            {/* Fila para mostrar los totales con un estilo diferente */}
                            <tr className='fila-totales'>
                                <td className='centrado'><strong>TOTAL</strong></td>
                                <td className='centrado'><strong>{totalHorasSuplementarias}</strong></td>
                                <td className='centrado'><strong>{totalHorasExtraordinarias}</strong></td>
                                {props.tipo === "PL" &&
                                    <td className='centrado'>

                                    </td>
                                }
                            </tr>
                        </tfoot>
                    </Table>
                </div>
            </>
        );

        return htmlRowsSolicitudes;
    }

    function GetHTMLServidorActividades(servidor: DetalleServidoresPlanificacionHE | DetalleServidoresProyHEDTO | DetalleServidoresModificacionHE): JSX.Element {

        const htmlRowsSolicitudes = (
            <>
                <div className="modal-body">
                    <TableActividadServidorHE
                        estadoPlanificacion={props.estadoPlanificacion}
                        actividades={servidor.actividadesplanificadas.map(a => a.value)}
                        ObtenerActividadesByRegimen={ObtenerActividadesByRegimenHE}
                        idRegimenLaboral={servidor.idregimenlaboral}
                        idPersona={servidor.idpersona}
                        rmu={servidor.rmu}
                        recargarInformacion={props.recargarInformacion}
                        paramsHorasMesPlanificacionHE={props.paramsHorasMesPlanificacionHE}
                        novedadesServidores={props.novedadesServidores}
                        onPlanificacionSave={handlePlanificacionSave}
                        onCancel={handleCancelarPlanificacion}
                        mensajeNovedad={props.mensajeNovedad}
                        tipo={esProyeccion ? "PR" : esModificacion ? "MD" : "PL"}
                        idUnidadAprueba={props.idUnidadAprueba}
                        nombreUnidadAprueba={props.nombreUnidadAprueba}
                        regimenLaboralesPlan={props.regimenLaboralesPlan}
                        puedeRealizarAccion={puedeRealizarAccion}
                        gruposActividad={props.gruposActividad}
                        factorMultiplicativo={factorMultiplicativo}
                    />
                </div>
            </>
        );

        return htmlRowsSolicitudes;
    }

    const handleCancelarPlanificacion = () => {
        setModalActividades(defaultStateModalGuardarAct)
    }

    const handlePlanificacionSave = (servidorPlanificado: DetalleServidorPlanHEDTO) => {

        //console.log(servidorPlanificado)

        servidorPlanificado.actividades = servidorPlanificado.actividades.filter(a => a.idEstructura === props.idUnidadAprueba)


        //Colocamos en 0 el valor de las horas si es que son null, para evitar problemas en el back
        var actividadesNormalized = [...servidorPlanificado.actividades];
        for (let index = 0; index < actividadesNormalized.length; index++) {
            const element = actividadesNormalized[index];
            if (element.nombreActividad) {
                element.horasExtraordinarias = element.horasExtraordinarias ?? 0
                element.horasSuplementarias = element.horasSuplementarias ?? 0
            }

        }

        servidorPlanificado.actividades = actividadesNormalized;

        //console.log(servidorPlanificado)
        setPlanificacionServidor(servidorPlanificado);
        const content: any = GetHTMLServidorPlanificado(servidorPlanificado)

        setModalConfirmacionActividad(
            {
                showModal: true,
                solicitud: servidorPlanificado,
                content
            })

    };

    async function showAlert(message, imageSrc, isSuccess) {
        Swal.fire({
            text: message,
            imageUrl: `${imageSrc}`,
            imageHeight: 100,
            imageAlt: isSuccess ? "Éxito" : "Error",
            confirmButtonText: "Entendido",
            confirmButtonColor: "#243165",
        });
    }

    const handleGuardarPlanificacion = async (servidorPlanificado: DetalleServidorPlanHEDTO) => {
        const result = await GuardarPlanificacionbyServidor(servidorPlanificado)
        if (result.status === 200) {
            if (typeof (result.dataResponse) === "string") {
                showAlert(result.dataResponse, ErrorSVG, true);
            }
            else {
                showAlert("La planificación de la actividad se ha guardado correctamente.", ExitoSVG, true);
            }
            
            setUpdatedDetalleServidores(result.dataResponse)
            await recargarInformacion();
        } else {
            showAlert(result.errorMessage, ErrorSVG, true);
            await recargarInformacion();
        }

        return 1;
    };

    const handleGuardarProyeccion = async (servidorPlanificado: DetalleServidorPlanHEDTO) => {
        const result = await GuardarProyeccionbyServidor(servidorPlanificado)
        if (result.status === 200 && result.dataResponse) {
            showAlert("La proyección de la actividad se ha guardado correctamente.", ExitoSVG, true);
            setUpdatedDetalleServidores(result.dataResponse)
            await recargarInformacion();
        } else {
            showAlert(result.errorMessage, ErrorSVG, true);
            await recargarInformacion();
        }

        return 1;
    };

    const handleGuardarModificacion = async (servidorPlanificado: DetalleServidorPlanHEDTO) => {
        if (props.fechaDesde && props.fechaHasta) {
            const result = await GuardarModificacionbyServidor(servidorPlanificado, props.fechaDesde, props.fechaHasta)
            if (result.status === 200 && result.dataResponse) {
                showAlert("La planificación de la actividad para la modificación de presupuesto se ha guardado correctamente.", ExitoSVG, true);
                setUpdatedDetalleServidores(result.dataResponse)
                await recargarInformacion();
            } else {
                showAlert(result.errorMessage, ErrorSVG, true);
                await recargarInformacion();
            }
        }
        else {
            showAlert("No ha seleciconado un rango de fecha", ErrorSVG, true)
            await recargarInformacion();
        }

        return 1;
    };

    //Esta funcion valida si es proyeccion o planificacion y determinar cual servicio sera llamado para guardar la actividad
    async function HandleGuardado(servidorPlanificado: DetalleServidorPlanHEDTO) {
        if (props.servidoresPlan.length > 0) {
            const proyplanifactividad = props.servidoresPlan[0];
            if (isParametroRegimenProyeccion(proyplanifactividad)) {
                return await handleGuardarProyeccion(servidorPlanificado)
            }
            else if (isParametroRegimenPlanificacion(proyplanifactividad)) {
                return await handleGuardarPlanificacion(servidorPlanificado)
            }
            else if (isParametroRegimenModificacion(proyplanifactividad)) {
                return await handleGuardarModificacion(servidorPlanificado)
            }

        }

        return -1
    }

    //Esta funcion valida si es proyeccion o planificacion y determinar el titulo que aparece en el modal
    function HandleTituloModal() {
        const tituloDefault = "Planificación de actividades"
        var titulo = tituloDefault;
        if (props.servidoresPlan.length > 0) {
            const proyplanifactividad = props.servidoresPlan[0];
            if (isParametroRegimenProyeccion(proyplanifactividad)) {
                titulo = "Proyección de actividades"
            }
            else if (isParametroRegimenPlanificacion(proyplanifactividad)) {
                titulo = "Planificación de actividades"
            }

        }

        return titulo;
    }

    //Esta funcion valida si es proyeccion o planificacion y determinar la pregunta que aparece en el modal
    function HandlePreguntaModal() {
        const mensajeDefault = "¿Está seguro/a que desea guardar la planificación del servidor?"
        var mensaje = mensajeDefault;
        if (props.servidoresPlan.length > 0) {
            const proyplanifactividad = props.servidoresPlan[0];
            if (isParametroRegimenProyeccion(proyplanifactividad)) {
                mensaje = "¿Está seguro/a que desea guardar la proyección del servidor?"
            }
            else if (isParametroRegimenPlanificacion(proyplanifactividad)) {
                mensaje = "¿Está seguro/a que desea guardar la planificación del servidor?"
            }
            else if (isParametroRegimenModificacion(proyplanifactividad)) {
                mensaje = "¿Está seguro/a que desea guardar la planificación del servidor para la solicitud de modificaión de presupuesto?"
            }

        }

        return mensaje;

    }

    const GenerarMensajeEncabezadoModal = (servidor: DetalleServidoresPlanificacionHE | DetalleServidoresProyHEDTO | DetalleServidoresModificacionHE, parametros: ParamsHorasMesPlanificacionHEDTO[] | null) => {

        var datosServidor

        var mensaje: string = ""
        if (props.tipo === "MD" && factorMultiplicativo) {
            
            if (parametros && parametros.length > 0) {
                const informacionParametros = parametros.find((v) => v.idregimenlaboral == servidor.idregimenlaboral)
                if (informacionParametros !== undefined) {
                    var regimenLaboral: string = informacionParametros.idregimenlaboral == 9 ? servidor.nombreregimenlaboral : servidor.siglasregimenlaboral;
                    if (informacionParametros.horasExtraySuple > 0) {
                        //mensaje = `La suma de horas suplementarias y extraordinarias no debe exceder de ${factorMultiplicativo * informacionParametros.horasExtraySuple} horas por servidor`
                        mensaje = `Ingrese el número total de horas suplementarias y extraordinarias para el periodo de ${factorMultiplicativo} meses seleccionado; recordando que para el personal de ${regimenLaboral}, las horas extras mensuales no deben exceder de ${informacionParametros.horasExtraySuple}.`;
                    }
                    else {
                        if (informacionParametros.horasExtraordinarias > 0 && informacionParametros.horasSuplementarias === 0) {
                            // mensaje = `Recuerde que las horas extraordinarias no deben exceder de ${factorMultiplicativo * informacionParametros.horasExtraordinarias} horas por servidor`
                            mensaje = `Ingrese el número total de horas extras extraordinarias para el periodo de ${factorMultiplicativo} meses seleccionado; recordando que para el personal de ${regimenLaboral}, las horas extras mensuales no deben exceder de ${informacionParametros.horasExtraordinarias}.`;
                        }
                        else if (informacionParametros.horasSuplementarias > 0 && informacionParametros.horasExtraordinarias === 0) {
                            // mensaje = `Recuerde que las horas suplementarias no deben exceder de ${factorMultiplicativo * informacionParametros.horasSuplementarias} horas por servidor`
                            mensaje = `Ingrese el número total de horas extras suplementarias para el periodo de ${factorMultiplicativo} meses seleccionado; recordando que para el personal de ${regimenLaboral}, las horas extras mensuales no deben exceder de ${informacionParametros.horasSuplementarias}.`;
                        }
                        else if (informacionParametros.horasSuplementarias > 0 && informacionParametros.horasExtraordinarias > 0) {
                            // mensaje = `Recuerde que las horas suplementarias  no deben exceder de ${factorMultiplicativo * informacionParametros.horasSuplementarias} horas y las extraordinarias de ${factorMultiplicativo * informacionParametros.horasExtraordinarias} horas por servidor`
                            mensaje = `Ingrese el número total de horas suplementarias y extraordinarias para el periodo de ${factorMultiplicativo} meses seleccionado; recordando que para el personal de ${regimenLaboral}, las horas extras mensuales no deben exceder de ${informacionParametros.horasSuplementarias} horas suplementarias y ${informacionParametros.horasExtraordinarias} horas extraordinarias.`;
                        }
                    }
                }   
            }
        }
        else {
            if (parametros && parametros.length > 0) {
                const informacionParametros = parametros.find((v) => v.idregimenlaboral == servidor.idregimenlaboral)
                if (informacionParametros !== undefined) {
                    if (informacionParametros.horasExtraySuple > 0) {
                        mensaje = `La suma de horas suplementarias y extraordinarias no debe exceder de ${informacionParametros.horasExtraySuple} horas por servidor`
                    }
                    else {
                        if (informacionParametros.horasExtraordinarias > 0 && informacionParametros.horasSuplementarias === 0) {
                            mensaje = `Recuerde que las horas extraordinarias no deben exceder de ${informacionParametros.horasExtraordinarias} horas por servidor`
                        }
                        else if (informacionParametros.horasSuplementarias > 0 && informacionParametros.horasExtraordinarias === 0) {
                            mensaje = `Recuerde que las horas suplementarias no deben exceder de ${informacionParametros.horasSuplementarias} horas por servidor`
                        }
                        else if (informacionParametros.horasSuplementarias > 0 && informacionParametros.horasExtraordinarias > 0) {
                            mensaje = `Recuerde que las horas suplementarias  no deben exceder de ${informacionParametros.horasSuplementarias} horas y las extraordinarias de ${informacionParametros.horasExtraordinarias} horas por servidor`
                        }
                    }


                }
            }
        }

        return mensaje;

    }


    //Funcion Para determinar si es Informacion de Proyeccion de Actividades
    function EsInformacionDeProyeccion(servidoresPlan: DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[]) {
        if (servidoresPlan.length > 0) {
            const proyplanifactividad = servidoresPlan[0];
            return isParametroRegimenProyeccion(proyplanifactividad)
        }
        else {
            return props.tipo === "PR"
        }
    }

    function EsInformacionDeModificacion(servidoresPlan: DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[]) {
        if (servidoresPlan.length > 0) {
            const modificacionactividad = servidoresPlan[0];
            return isParametroRegimenModificacion(modificacionactividad)
        }
        else {
            return props.tipo === "MD"
        }
    }


    const esProyeccion = EsInformacionDeProyeccion(props.servidoresPlan);
    const esModificacion = EsInformacionDeModificacion(props.servidoresPlan);

    function GetTBodyTabla(currentRows: DetalleServidoresPlanificacionHE[] | DetalleServidoresProyHEDTO[] | DetalleServidoresModificacionHE[], novedadesServidores: NovedadesServidoresHEDTO[]) {

        if (esProyeccion) {
            const contenido = (currentRows as DetalleServidoresProyHEDTO[]).map((serv, idServ) => {


                var estadoMostrar: string = serv.strestadoproyeccion
                const globalIndex = indexOfFirstRow + idServ + 1
                //console.log(serv)
                return (
                    <React.Fragment key={idServ}>

                        <tr className='rows_tabla_planificacion_he'>
                            {/* <td className="centrado">{serv.contador}</td> */}
                            <td className="centrado">{globalIndex}</td>
                            <td className="centrado">{serv.identificacion}</td>
                            <td colSpan={2}>{serv.nombrescompletos}</td>
                            <td colSpan={2}>{serv.cargo}</td>
                            <td className="centrado">{serv.siglasregimenlaboral}</td>
                            {
                                esProyeccion &&
                                <td className="centrado">{serv.nombreestructuraorganica}</td>
                            }
                            {
                                !esProyeccion && (
                                    <td className="centrado">
                                        <div className='containerValorDineroProyectado'>
                                            <NumberFormat value={serv.rmu ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                        </div>
                                    </td>
                                )
                            }

                            <td className="centrado">{serv.numactividades}</td>
                            <td className="centrado">{serv.horassuplementarias}</td>
                            <td className="centrado">{serv.horasextraordinarias}</td>
                            <td className="centrado">{serv.horastotales}</td>
                            {
                                !esProyeccion && (
                                    <React.Fragment>
                                        <td className="centrado">
                                            <div className='containerValorDineroProyectado'>
                                                <NumberFormat value={serv.valorhorassuplementarias ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                            </div>
                                        </td>
                                        <td className="centrado">
                                            <div className='containerValorDineroProyectado'>
                                                <NumberFormat value={serv.valorhorasextraordinarias ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                            </div>
                                        </td>
                                        <td className="centrado">
                                            <div className='containerValorDineroProyectado'>
                                                <NumberFormat value={serv.valortotal ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                            </div>
                                        </td>
                                    </React.Fragment>
                                )
                            }

                            <td className="centrado">{estadoMostrar}</td>
                            <td className="centrado" colSpan={2}>
                                <a className="btn-detalles" title="Ver Actividades" onClick={() => handleExpandRow(serv.idpersona)}><VerSvg className='icono-svg' /></a>
                                {novedadesServidores.some(nov => nov.idPersona === serv.idpersona) && (
                                    <a className="btn-detalles" title="Ver Novedades" onClick={() => showNovedadesModal(serv.idpersona)}><NovedadesSVG className='icono-svg' /></a>
                                )}
                            </td>
                        </tr>
                        {/* {expandedRows[serv.idpersona] && (
                            <tr>
                                <td colSpan={17} style={{ background: '#f9f9f9' }}>
                                    <div style={{ margin: '3rem' }}>
                                        <TableActividadServidorHE
                                            estadoPlanificacion={props.estadoPlanificacion}
                                            actividades={serv.actividadesplanificadas.map(a => a.Value)}
                                            ObtenerActividadesByRegimen={ObtenerActividadesByRegimenHE}
                                            idRegimenLaboral={serv.idregimenlaboral}
                                            idPersona={serv.idpersona}
                                            rmu={serv.rmu}
                                            recargarInformacion={props.recargarInformacion}
                                            paramsHorasMesPlanificacionHE={props.paramsHorasMesPlanificacionHE}
                                            novedadesServidores={props.novedadesServidores}
                                            onPlanificacionSave={handlePlanificacionSave}
                                            mensajeNovedad={props.mensajeNovedad}
                                            tipo={esProyeccion ? "PR" : "PL"}
                                            idUnidadAprueba={props.idUnidadAprueba}
                                            nombreUnidadAprueba={props.nombreUnidadAprueba}
                                            gruposActividad = {props.gruposActividad}
                                        />
                                    </div>
                                </td>
                            </tr>
                        )} */}
                    </React.Fragment>
                )
            })

            return contenido;
        }
        else if (esModificacion) {
            const contenido = (currentRows as DetalleServidoresModificacionHE[]).map((serv, idServ) => {


                var estadoMostrar: string = serv.strestadomodificacion

                const globalIndex = indexOfFirstRow + idServ + 1

                return (
                    <React.Fragment key={idServ}>

                        <tr className='rows_tabla_planificacion_he'>
                            {/* <td className="centrado">{serv.contador}</td> */}
                            <td className="centrado">{globalIndex}</td>
                            <td className="centrado">{serv.identificacion}</td>
                            <td colSpan={2}>{serv.nombrescompletos}</td>
                            <td colSpan={2}>{serv.cargo}</td>
                            <td className="centrado">{serv.siglasregimenlaboral}</td>
                            {
                                esProyeccion &&
                                <td className="centrado">{serv.nombreestructuraorganica}</td>
                            }
                            {
                                !esProyeccion && (
                                    <td className="centrado">
                                        <div className='containerValorDineroProyectado'>
                                            <NumberFormat value={serv.rmu ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                        </div>
                                    </td>
                                )
                            }

                            <td className="centrado">{serv.numactividades}</td>
                            <td className="centrado">{serv.horassuplementarias}</td>
                            <td className="centrado">{serv.horasextraordinarias}</td>
                            <td className="centrado">{serv.horastotales}</td>
                            {
                                !esProyeccion && (
                                    <React.Fragment>
                                        <td className="centrado">
                                            <div className='containerValorDineroProyectado'>
                                                <NumberFormat value={serv.valorhorassuplementarias ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                            </div>
                                        </td>
                                        <td className="centrado">
                                            <div className='containerValorDineroProyectado'>
                                                <NumberFormat value={serv.valorhorasextraordinarias ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                            </div>
                                        </td>
                                        <td className="centrado">
                                            <div className='containerValorDineroProyectado'>
                                                <NumberFormat value={serv.valortotal ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                            </div>
                                        </td>
                                    </React.Fragment>
                                )
                            }

                            <td className="centrado">{estadoMostrar}</td>
                            <td className="centrado" colSpan={2}>
                                <a className="btn-detalles" title="Editar Actividades" onClick={() => handleExpandRow(serv.idpersona)}><EditarSvg className='icono-svg' /></a>
                                {novedadesServidores.some(nov => nov.idPersona === serv.idpersona) && (
                                    <a className="btn-detalles" title="Ver Novedades" onClick={() => showNovedadesModal(serv.idpersona)}><NovedadesSVG className='icono-svg' /></a>
                                )}
                            </td>
                        </tr>
                        {/* {expandedRows[serv.idpersona] && (
                            <tr>
                                <td colSpan={17} style={{ background: '#f9f9f9' }}>
                                    <div style={{ margin: '3rem' }}>
                                        <TableActividadServidorHE
                                            estadoPlanificacion={props.estadoPlanificacion}
                                            actividades={serv.actividadesplanificadas.map(a => a.Value)}
                                            ObtenerActividadesByRegimen={ObtenerActividadesByRegimenHE}
                                            idRegimenLaboral={serv.idregimenlaboral}
                                            idPersona={serv.idpersona}
                                            rmu={serv.rmu}
                                            recargarInformacion={props.recargarInformacion}
                                            paramsHorasMesPlanificacionHE={props.paramsHorasMesPlanificacionHE}
                                            novedadesServidores={props.novedadesServidores}
                                            onPlanificacionSave={handlePlanificacionSave}
                                            mensajeNovedad={props.mensajeNovedad}
                                            tipo={esProyeccion ? "PR" : "PL"}
                                            idUnidadAprueba={props.idUnidadAprueba}
                                            nombreUnidadAprueba={props.nombreUnidadAprueba}
                                            gruposActividad = {props.gruposActividad}
                                        />
                                    </div>
                                </td>
                            </tr>
                        )} */}
                    </React.Fragment>
                )
            })

            return contenido;
        }
        else {
            const contenido = (currentRows as DetalleServidoresPlanificacionHE[]).map((serv, idServ) => {


                var estadoMostrar: string = serv.strestadoplanificacion

                const globalIndex = indexOfFirstRow + idServ + 1

                return (
                    <React.Fragment key={idServ}>

                        <tr className='rows_tabla_planificacion_he'>
                            {/* <td className="centrado">{serv.contador}</td> */}
                            <td className="centrado">{globalIndex}</td>
                            <td className="centrado">{serv.identificacion}</td>
                            <td colSpan={2}>{serv.nombrescompletos}</td>
                            <td colSpan={2}>{serv.cargo}</td>
                            <td className="centrado">{serv.siglasregimenlaboral}</td>
                            {
                                esProyeccion &&
                                <td className="centrado">{serv.nombreestructuraorganica}</td>
                            }
                            {
                                !esProyeccion && (
                                    <td className="centrado">
                                        <div className='containerValorDineroProyectado'>
                                            <NumberFormat value={serv.rmu ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                        </div>
                                    </td>
                                )
                            }

                            <td className="centrado">{serv.numactividades}</td>
                            <td className="centrado">{serv.horassuplementarias}</td>
                            <td className="centrado">{serv.horasextraordinarias}</td>
                            <td className="centrado">{serv.horastotales}</td>
                            {
                                !esProyeccion && (
                                    <React.Fragment>
                                        <td className="centrado">
                                            <div className='containerValorDineroProyectado'>
                                                <NumberFormat value={serv.valorhorassuplementarias ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                            </div>
                                        </td>
                                        <td className="centrado">
                                            <div className='containerValorDineroProyectado'>
                                                <NumberFormat value={serv.valorhorasextraordinarias ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                            </div>
                                        </td>
                                        <td className="centrado">
                                            <div className='containerValorDineroProyectado'>
                                                <NumberFormat value={serv.valortotal ?? ""} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'$'} decimalScale={2} fixedDecimalScale={true} />

                                            </div>
                                        </td>
                                    </React.Fragment>
                                )
                            }

                            <td className="centrado">{estadoMostrar}</td>
                            <td className="centrado" colSpan={2}>
                                <a className="btn-detalles" title="Editar Actividades" onClick={() => handleExpandRow(serv.idpersona)}><EditarSvg className='icono-svg' /></a>
                                {novedadesServidores.some(nov => nov.idPersona === serv.idpersona) && (
                                    <a className="btn-detalles" title="Ver Novedades" onClick={() => showNovedadesModal(serv.idpersona)}><NovedadesSVG className='icono-svg' /></a>
                                )}
                            </td>
                        </tr>
                        {/* {expandedRows[serv.idpersona] && (
                            <tr>
                                <td colSpan={17} style={{ background: '#f9f9f9' }}>
                                    <div style={{ margin: '3rem' }}>
                                        <TableActividadServidorHE
                                            estadoPlanificacion={props.estadoPlanificacion}
                                            actividades={serv.actividadesplanificadas.map(a => a.Value)}
                                            ObtenerActividadesByRegimen={ObtenerActividadesByRegimenHE}
                                            idRegimenLaboral={serv.idregimenlaboral}
                                            idPersona={serv.idpersona}
                                            rmu={serv.rmu}
                                            recargarInformacion={props.recargarInformacion}
                                            paramsHorasMesPlanificacionHE={props.paramsHorasMesPlanificacionHE}
                                            novedadesServidores={props.novedadesServidores}
                                            onPlanificacionSave={handlePlanificacionSave}
                                            mensajeNovedad={props.mensajeNovedad}
                                            tipo={esProyeccion ? "PR" : "PL"}
                                            idUnidadAprueba={props.idUnidadAprueba}
                                            nombreUnidadAprueba={props.nombreUnidadAprueba}
                                            gruposActividad = {props.gruposActividad}
                                        />
                                    </div>
                                </td>
                            </tr>
                        )} */}
                    </React.Fragment>
                )
            })

            return contenido;
        }

    }


    const onClickVerDoc = useCallback(
        async (referencia: string) => {
            setstateModalVP({ ...stateModalVP, loading: true })
            const datosUsuario: UserData = authenticationService.currentUserValue;
            const url = await GetDocumentVistaPrevia(referencia, datosUsuario.token);
            setstateModalVP({ ...stateModalVP, loading: false, url })
        }, [stateModalVP]
    )


    return (
        <React.Fragment>
            <Row className="justify-content-end row-no-margin">

                {props.mostrarReporteResumenProyPlanifExcel && typeof (props.descargarResumenExcel) === "function" && (
                    <Col className="d-flex" md="auto">
                        <Button
                            disabled={props.loadingAccionReporteExcel}
                            onClick={props.descargarResumenExcel}
                            className="btn-Excel "
                        >
                            <div className="containerBotonImprimir">
                                <div>Exportar a Excel</div>
                                <IconoExcel className="iconBotonImprimir" />
                            </div>
                        </Button>
                    </Col>

                )}
                {puedeRealizarAccion && (
                    <>
                        {props.mostrarGuardarParcial && (
                            <Col className="d-flex" md="auto">
                                <Button className="btn-guardar" onClick={props.guardarParcial}>
                                    Guardar
                                </Button>
                            </Col>
                        )}
                        {props.mostrarFirmaryEnviar && (
                            <Col className="d-flex" md="auto">
                                <Button className="btn-firmar" onClick={props.firmaryEnviar}>
                                    {props.tipo === "PL" ? "Firmar y enviar a TH" : props.tipo === "MD" ? "Firmar y enviar GPE" : "Enviar a TH"}
                                </Button>
                            </Col>
                        )}

                    </>
                )}

                {props.mostrarSolicitarReverso && (
                    <Col className="d-flex" md="auto">
                        <Button className="btn-solicitar" onClick={props.solicitarReverso}>
                            Solicitar reverso
                        </Button>
                    </Col>
                )}

                {props.docPlanificacionUnidad !== undefined && (
                    <>
                        {props.idPlanificacionUnidad !== 0 && (
                            <>
                                {props.estadoPlanificacion.trim() !== 'RE' && (
                                    <Col className="d-flex" md="auto">
                                        <Button className="btn-ver-pdf" title="Ver PDF" onClick={() => onClickVerDoc(props.docPlanificacionUnidad ? props.docPlanificacionUnidad : "")}>
                                            Ver PDF <PdfSVG />
                                        </Button>
                                    </Col>
                                )}
                            </>
                        )}

                    </>
                )}


            </Row>
            <Row className="row-no-margin">
                <Col md="9">
                    <div className="d-flex align-items-center justify-content-start">
                        <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                        <select
                            id="rowsPerPageSelect"
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="custom-select custom-select-sm mr-2" // Ajusta el tamaño del select
                            style={{ width: 'auto' }} // Asegura que el select no tome más espacio del necesario
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                        </select>
                        <Label className="mb-0">filas</Label>
                    </div>
                </Col>
                <Col md="3">
                    <Input
                        type="text"
                        placeholder="Buscar..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="form-control-sm" // Reduce el tamaño del input
                    />
                </Col>

            </Row>
            <Table responsive bordered className="table_planificacion_he">
                <thead className="cabeceras_tabla_planificacion_he">
                    <tr className="borde_cabeceras_he">
                        <th colSpan={1} onClick={() => handleSort('#')}>#</th>
                        <th colSpan={1} onClick={() => handleSort('identificacion')}>Identificación</th>
                        <th colSpan={2} onClick={() => handleSort('nombrescompletos')}>Nombres</th>
                        <th colSpan={2} onClick={() => handleSort('cargo')}>Cargo</th>
                        <th colSpan={1} onClick={() => handleSort('siglasregimenlaboral')}>Régimen</th>
                        {esProyeccion && <th colSpan={1} onClick={() => handleSort('nombreestructuraorganica')}>Unidad</th>}
                        {!esProyeccion && <th colSpan={1} onClick={() => handleSort('rnu')}>Sueldo ($)</th>}
                        <th colSpan={1} onClick={() => handleSort('numactividades')}>Núm.<br />Actividades</th>
                        <th colSpan={1} onClick={() => handleSort('horassuplementarias')}> {props.tipo === "PL" || "MD" ? "H. Suplementarias" : "Horas Suplementarias"}</th>
                        <th colSpan={1} onClick={() => handleSort('horasextraordinarias')}>{props.tipo === "PL" || "MD" ? "H. Extraordinarias" : "Horas Extraordinarias"}</th>
                        <th colSpan={1} onClick={() => handleSort('horastotales')}>Total Horas</th>

                        {!esProyeccion && (
                            <React.Fragment>
                                <th colSpan={1} onClick={() => handleSort('valorhorassuplementarias')}>Presupuesto<br />H. Suplementarias ($)</th>
                                <th colSpan={1} onClick={() => handleSort('valorhorasextraordinarias')}>Presupuesto<br />H. Extraordinarias ($)</th>
                                <th colSpan={1} onClick={() => handleSort('valorhorasextraordinarias')}>Presupuesto<br />Total ($)</th>
                            </React.Fragment>

                        )}

                        <th colSpan={1} onClick={() => handleSort('estado')}>Estado</th>
                        <th colSpan={2}>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {GetTBodyTabla(currentRows, novedadesServidores)}
                </tbody>
            </Table>
            <Pagination size="sm" className="pagination_planificacion_he">
                {renderPageNumbers}
            </Pagination>
            <ModalConfirmacionNew
                show={modalConfirmacionActividad.showModal}
                size="lg"
                onClose={() => {
                    setModalConfirmacionActividad(defaultStateModalConfirmacionAct);
                }}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={HandlePreguntaModal()}
                nombreBotonAccion={"Aceptar"}
                nombreBotonCerrarModal={"Cancelar"}
                asyncOnClick={async () => await HandleGuardado(modalConfirmacionActividad.solicitud)} //await handleGuardarPlanificacion(modalConfirmacionActividad.solicitud)}
                contentModal={modalConfirmacionActividad.content}
                tituloModal={HandleTituloModal()}
                botonesAccionParteSuperior={true}
                iconModal={SaveSVG}
            />

            <ModalConfirmacionNew
                show={modalActividades.showModal}
                size="xl"
                onClose={() => setModalActividades(defaultStateModalGuardarAct)}
                asyncAccion={false}
                closeAfterAccion={true}
                nombreBotonAccion="Cerrar"
                contentModal={modalActividades.content}
                tituloModal={modalActividades.tituloModal}
                botonesAccionParteSuperior={true}
                hideBotonCerrar={true}
                mensajeEncabezado={modalActividades.mensajeEncabezado}
                // iconModal={SaveSVG} 
                asyncClose={false} mensajeConfirmacion={''} />

            <ModalVistaPreviaDocumentos
                cargandoDatos={stateModalVP.loading}
                onClose={() => setstateModalVP(defaultStateModalVistaPrevia)}
                show={stateModalVP.loading || stateModalVP.url !== ""}
                size="xl"
                tituloModal='Documento planificación de la unidad'
                urlArchivo={stateModalVP.url}
                botonCerrar={true}
            />
        </React.Fragment>

    )
}
